<template>
    <div class="table" ref="user">
        <div class="container">
            <div class="handle-box">
                <el-row :gutter="10" >
                    <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="4">
                        <!-- <el-row>
                            <el-col :span="4"> -->
                                <span class="label">激活状态</span>
                            <!-- </el-col>
                            <el-col :span="18"> -->
                                <el-select size="mini" v-model="searchParam.state" clearable placeholder="请选择"  class="handle-select">
                                    <el-option key="0" label="未激活" value="0"></el-option>
                                    <el-option key="1" label="已激活" value="1"></el-option>
                                </el-select>
                            <!-- </el-col>
                        </el-row> -->
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="4" >
                        <span class="label">剩余次数</span>
                        <el-input-number size="mini" v-model="searchParam.chance" :min="0" controls-position="right" class="handle-input"></el-input-number>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="4">
                        <span class="label">邮&emsp;&emsp;箱</span>
                        <el-input size="mini" v-model="searchParam.email" placeholder="邮箱" clearable @clear="searchParam.email = null" class="handle-input"></el-input>
                    </el-col>
                    <el-col   :xs="12" :sm="12" :md="8" :lg="8" :xl="4">
                        <span class="label">姓&emsp;&emsp;名</span>
                        <el-input size="mini" v-model="searchParam.chName" label="姓名" placeholder="姓名" clearable @clear="searchParam.chName = null" class="handle-input"></el-input>
                    </el-col>
                    <el-col   :xs="12" :sm="12" :md="8" :lg="8" :xl="4">
                        <span class="label">单&emsp;&emsp;位</span>
                        <el-input size="mini" v-model="searchParam.company" placeholder="单位" clearable @clear="searchParam.email = null" class="handle-input"></el-input>
                    </el-col>
                    <el-col   :xs="12" :sm="12" :md="8" :lg="8" :xl="4">
                        <span class="label">职&emsp;&emsp;务</span>
                        <el-input size="mini" v-model="searchParam.title" placeholder="职务" clearable @clear="searchParam.title = null" class="handle-input"></el-input>
                    </el-col>
                    <el-col   :xs="12" :sm="12" :md="8" :lg="8" :xl="4">
                        <span class="label">培训机构</span>
                        <el-input size="mini" v-model="searchParam.institutions" placeholder="培训机构" clearable @clear="searchParam.tel = null" class="handle-input"></el-input>
                    </el-col>
                    <el-col   :xs="12" :sm="12" :md="8" :lg="8" :xl="4">
                        <span class="label">科&emsp;&emsp;目</span>
                        <el-select size="mini" v-model="searchParam.subjectIdList" clearable multiple collapse-tags placeholder="科目">
                            <el-option v-for="item in subjectList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="8">
                        <span class="label">创建时间</span>
                        <el-date-picker
                             size="mini"
                            style="width:200px"
                            v-model="searchParam.startTime"
                            type="datetime"
                            placeholder="开始时间"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="'00:00:00'">
                        </el-date-picker>
                        <span class="label" style="margin:0 5px;">至</span>
                        <el-date-picker
                             size="mini"
                            style="width:200px"
                            v-model="searchParam.endTime"
                            type="datetime"
                            placeholder="结束时间"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="'00:00:00'">
                        </el-date-picker>
                    </el-col>
                </el-row>
                <el-row type="flex"  justify="end">

                    <el-button size="mini" type="primary" icon="el-icon-search" @click="getData">搜索</el-button>
                    <el-button size="mini" type="primary" icon="el-icon-circle-plus-outline" @click="addVisible = true">添加</el-button>
                    <el-button size="mini" type="primary" icon="el-icon-download" @click="downloadTemplate">学员导入模板</el-button>
                    <el-upload class="upload" action="/api/manage/user/insertBatch" :multiple=false :show-file-list=false accept=".xls, .xlsx" :before-upload="beforeUpload" :on-success="uploadSuccess" :on-error="uploadError">
                        <el-button size="mini" type="primary" icon="el-icon-upload2">导入</el-button>
                    </el-upload>
                    <el-button size="mini" type="primary" icon="el-icon-download" @click="exportUser">导出</el-button>
                    <router-link to="/exception" style="margin-left:10px">
                        <el-button size="mini" type="primary" icon="el-icon-warning">导入异常</el-button>
                    </router-link>
                </el-row>
            </div>
            <el-table :data="tableData" border stripe style="width: 100%;"  ref="multipleTable" :max-height="tableLen" @selection-change="handleSelectionChange" v-on: >
                <el-table-column prop="createTime" label="创建时间" width="150" fixed align="center"></el-table-column>
                <el-table-column prop="chName" label="姓名" width="120" fixed></el-table-column>
                <el-table-column prop="enName" label="姓名拼音" width="120"></el-table-column>
                <el-table-column prop="email" label="邮箱" width="150"></el-table-column>
                <el-table-column prop="tel" label="手机号码" width="120"></el-table-column>
                <el-table-column prop="company" label="单位" min-width="200"></el-table-column>
                <el-table-column prop="title" label="职务" min-width="200"></el-table-column>
                <el-table-column prop="institutions" label="培训机构" min-width="200"></el-table-column>
                <el-table-column prop="state" label="激活状态" width="80">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.state === 0" type="primary" disable-transitions>未激活</el-tag>
                        <el-tag v-if="scope.row.state === 1" type="success" disable-transitions>已激活</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="faceCertify" label="实名认证" width="150">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.faceCertify === -1" type="success" disable-transitions>已认证(免)</el-tag>
                        <el-tag v-if="scope.row.faceCertify === 0 || scope.row.faceCertify === null" type="primary" disable-transitions>未认证</el-tag>
                        <el-tag v-if="scope.row.faceCertify === 1" type="success" disable-transitions>已认证</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="科目" width="240">
                    <template slot-scope="scope2">
                       <ul class="moreColumn">
                           <li v-for="(item,i) in scope2.row['frequencyList']" :key="i" >{{item.subjectName}}</li>
                       </ul>
                    </template>
                </el-table-column>
                <el-table-column label="剩余次数" width="80" align="center">
                    <template slot-scope="scope3">
                       <ul class="moreColumn">
                           <li v-for="(item,i) in scope3.row.frequencyList" :key="i" >{{item.chance}}</li>
                       </ul>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="250">
                    <template slot-scope="scope">
                        <el-button size="small" type="primary" @click="edit(scope.$index, scope.row)">编辑</el-button>
                        <el-button size="small" type="primary" @click="excuseFaceCeritify(scope.$index, scope.row)">免认证</el-button>
                        <el-button size="small" type="danger" @click="editFrequency(scope.$index, scope.row)">授权</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination @current-change="getData" @size-change="getData" :current-page.sync="searchParam.pageNum" :page-size.sync="searchParam.pageSize" layout="total,sizes,prev, pager, next" :total="totalNumber">
                </el-pagination>
            </div>
        </div>

        <!-- 单个添加框 -->
        <el-dialog title="添加" :visible.sync="addVisible" width="30%" @closed="clearValidate('addForm')">
            <el-form ref="addForm" :model="addForm" :rules="editOrAddUserRules" label-width="100px">
                <el-form-item label="邮 箱" prop="email">
                    <el-input v-model="addForm.email"></el-input>
                </el-form-item>
                <el-form-item label="身份证号码" prop="certNo">
                    <el-input v-model="addForm.certNo"></el-input>
                </el-form-item>
                <el-form-item label="姓 名" prop="chName">
                    <el-input v-model="addForm.chName"></el-input>
                </el-form-item>
                <el-form-item label="姓名拼音">
                    <el-input v-model="addForm.enName"></el-input>
                </el-form-item>
                <el-form-item label="手机号码">
                    <el-input v-model="addForm.tel"></el-input>
                </el-form-item>
                <el-form-item label="单 位">
                    <el-input v-model="addForm.company"></el-input>
                </el-form-item>
                <el-form-item label="职 务">
                    <el-input v-model="addForm.title"></el-input>
                </el-form-item>
                <el-form-item label="培训机构">
                    <el-input v-model="addForm.institutions"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveAdd">保 存</el-button>
            </span>
        </el-dialog>

        <!-- 编辑弹出框 -->
        <el-dialog title="编辑" :visible.sync="editVisible" width="30%" @closed="clearValidate('editForm')">
            <el-form ref="editForm" :model="editForm" :rules="editOrAddUserRules" label-width="100px">
                <!-- <el-form-item label="日期">
                    <el-date-picker type="date" placeholder="选择日期" v-model="form.date" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
                </el-form-item> -->
                <el-form-item label="邮  箱" prop="email">
                    <el-input v-model="editForm.email"></el-input>
                </el-form-item>
                <el-form-item label="身份证号码" prop="certNo">
                    <el-input v-model="editForm.certNo"></el-input>
                </el-form-item>
                <el-form-item label="姓  名" prop="chName">
                    <el-input v-model="editForm.chName"></el-input>
                </el-form-item>
                <el-form-item label="姓名拼音">
                    <el-input v-model="editForm.enName"></el-input>
                </el-form-item>
                <el-form-item label="手机号码">
                    <el-input v-model="editForm.tel"></el-input>
                </el-form-item>
                <el-form-item label="单  位">
                    <el-input v-model="editForm.company"></el-input>
                </el-form-item>
                <el-form-item label="职  务">
                    <el-input v-model="editForm.title"></el-input>
                </el-form-item>
                <el-form-item label="培训机构">
                    <el-input v-model="editForm.institutions"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">保 存</el-button>
            </span>
        </el-dialog>

        <!-- 单个授权框 -->
        <el-dialog title="授权" :visible.sync="editFrequencyVisible" width="700px" @closed="closeFrequencyForm">
            <el-table :data="frequencyForm" stripe style="width: 100%">
                <el-table-column prop="subject.name" label="科目"></el-table-column>
                <el-table-column prop="name" label="次数" width="150px">
                    <template slot-scope="scope">
                        <el-input-number v-model="scope.row.chance" :min="0"></el-input-number>
                        <!-- <el-button
                        size="mini"
                        @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                        <el-button
                        size="mini"
                        type="danger"
                        @click="handleDelete(scope.$index, scope.row)">删除</el-button> -->
                    </template>
                </el-table-column>
                <el-table-column prop="expireTime" label="过期时间">
                    <template slot-scope="scope">
                    <el-date-picker v-model="scope.row.expireTime" :picker-options="pickerOptions" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" default-time="00:00:00"></el-date-picker>
                    </template>
                </el-table-column>
            </el-table>
             <span slot="footer" class="dialog-footer">
                <el-button @click="editFrequencyVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveFrequency">保 存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: 'user',
        data() {
            const certNoValidator=(rule,value,callback) => {
                console.log(value)
                const cert = new RegExp(/^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/);
                const cert2 = new RegExp(/^[a-zA-Z]\d{6}\([\dA]\)$/);
                if (value && !cert.test(value) && !cert2.test(value)) {
                    callback(new Error("请出入正确的身份证号码"));
                } else {
                    callback();
                }
            };

            return {
                tableLen:350,
                searchParam:{
                    pageNum:1,
                    pageSize:20
                },
                totalNumber:0,
                tableData: [],//列表中的数据
                subjectList:[],
                multipleSelection: [],
                clearChance:false,
                addVisible:false,
                addBatchVisible:false,
                editVisible: false,
                editFrequencyVisible: false,
                addForm:{},
                editForm:{},
                frequencyForm:[],
                editOrAddUserRules:{
                    email:[{required: true, message: '请输入邮箱', trigger: 'blur'}],
                    chName:[{required: true, message: '请输入姓名', trigger: 'blur'}],
                    certNo: [
                        {required: false, message: "请输入身份证号码", trigger: ["blur"]},
                        {validator:certNoValidator, trigger: ["blur"]}
                    ],
                },
                uploadInstance:null,
                pickerOptions:{
                    disabledDate(dateTime) {
                        return dateTime.getTime() < Date.now();
                    }
                }
            }
        },
        created() {
            this.getData();
            this.getSubjectList();
        },
        updated() {
            // this.tableLen=window.innerHeight-document.getElementsByClassName('handle-box')[0].clientHeight-195;
            this.tableLen=window.innerHeight-135;
        },
        methods: {
            async getSubjectList() {
                let res = await this.$axios.get("/manage/subject/selectAll");
                if (res.code == 200) {
                    this.subjectList = res.data;
                }
            },
            async getData() {
                let res = await this.$axios.post('/manage/user/selectByPage',this.searchParam);
                if (res.code == 200) {
                    this.tableData = res.data.list;
                    this.totalNumber = res.data.total;
                } else {
                    this.$message.error(res.errMsg);
                }
            },
            async downloadTemplate() {
                let res = await this.downloadGet('/manage/user/downloadTemplate');
                if (res.code != 200) {
                    this.$message.error("下载失败");
                }
            },
            async exportUser() {
                let res = await this.downloadPost('/manage/user/exportUser', this.searchParam);
                if (res.code != 200) {
                    this.$message.error(`导出失败:${res.errMsg}`);
                }
            },
            async saveAdd() {
                let valid = await this.$refs.addForm.validate().catch(err=>{return Promise.resolve(false)});
                if (!valid) {
                    return;
                }

                let res = await this.$axios.post('/manage/user/insert',this.addForm);
                if (res.code != 200) {
                    this.$message.error(res.errMsg);
                    return;
                }

                this.$refs.addForm.resetFields();
                this.addVisible = false;
                this.$message.success("保存成功");
                this.getData();
            },
            edit(index, row) {
                this.editForm = this.$ObjectUtil.cloneObj(row);
                this.editVisible = true;
            },
            // 保存编辑
            async saveEdit() {
                let valid = await this.$refs.editForm.validate().catch(err=>{return Promise.resolve(false)});
                if (!valid) {
                    return;
                }

                let res = await this.$axios.post('/manage/user/update',this.editForm);
                if (res.code != 200) {
                    this.$message.error(res.errMsg);
                    return;
                }

                this.$refs.editForm.resetFields();
                this.editVisible = false;
                this.$message.success("保存成功");
                this.getData();
            },
            async excuseFaceCeritify(index,row) {
                let res = await this.$axios.get(`/manage/user/excuseFaceCeritify/${row.id}`);
                if (res.code != 200) {
                    this.$message.error(res.errMsg);
                }
                this.getData()

            },
            async editFrequency(index, row) {
                let res = await this.$axios.get(`/manage/frequency/selectByUserId/${row.id}`);
                if (res.code != 200) {
                    this.$message.error(res.errMsg);
                    return;
                }

                this.frequencyForm = res.data;
                this.editFrequencyVisible = true;
            },
            async saveFrequency() {
                console.log(this.frequencyForm);
                let data = this.frequencyForm.map(obj => {
                    for (let key in obj) {
                        if (key !== "chance" && key !== "userId" && key !== "subjectId" && key != "expireTime") {
                            obj[key] = null;
                        }
                    }
                    return obj;
                })

                let flag = false;
                for (let frequenct of this.frequencyForm) {
                    if (frequenct.chance > 0 && new Date(frequenct.expireTime) <= new Date()) {
                        flag = true;
                    }
                }

                if (flag) {
                    let confirm = await this.$confirm('当前授权含有不正确数据（次数不为0但有效期小于系统当前时间），是否继续保存授权数据？',{type:'warning'}).catch(err=>{return Promise.resolve(false)});
                    if (!confirm) {
                        return;
                    }
                }


                let res = await this.$axios.post("/manage/frequency/updateBatch", this.frequencyForm);
                if (res.code != 200) {
                    this.$message.error(res.errMsg);
                    return;
                }
                this.$message.success("保存成功");
                this.editFrequencyVisible = false;
            },
            closeFrequencyForm() {
                this.frequencyForm = [];
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            clearValidate(form) {
                this.$refs[form].clearValidate();
            },
            beforeUpload(file) {
                let validate = false;
                if (file && file.name) {
                    let name = file.name;
                    let ext = name.substring(name.lastIndexOf(".")+1, name.length);
                    if (ext == "xls" || ext == "xlsx") {
                        validate = true;
                    }
                }
                if (!validate) {
                    this.$message.error("只能上传'.xls'或者'.xlsx'文件");
                    return;
                }

                if (file.size / 1024 / 1024 > 2) {
                    this.$message.error("只能上传小于2M的文件");
                }
                console.debug(file);
                this.uploadInstance = this.$loading({lock:true, text:'上传处理中……', background: 'rgba(0, 0, 0, 0.7)'});
            },
            uploadSuccess(res) {
                this.uploadInstance.close();
                if (res.code == 200 && res.data == 0) {
                    this.$message.success("上传处理成功");
                } else if (res.code == 200) {
                    this.$message.warning("上传处理成功，存在" + res.data+ "条异常情况");
                }else {
                    this.$message.error(res.errMsg);
                }
                this.getData();
            },
            uploadError() {
                this.uploadInstance.close();
                this.$message.error('上传处理失败');
            }
        }
    }

</script>

<style scoped>
.handle-box {
    margin-bottom: 10px;
}
.el-row {
    margin-bottom: 5px;
}
.el-col{
    margin: 5px 0;
}
.del-dialog-cnt {
    font-size: 16px;
    text-align: center;
}
.action {
    display: inline;
    /* float: left; */
}
.action:first-child {
    margin-right: 5px;
}

.upload {
    display: inline;
    margin-left: 10px;
    margin-right: 10px;
}
.moreColumn li{
    list-style: none;
    line-height:34px;
    margin: 0 -10px;
    padding: 0 10px;
}
.moreColumn li+li{
        border-top: 1px solid #ebeef5;
}
.moreColumn li:first-child {
    margin-top: -8px;
}
.moreColumn li:last-child{
    margin-bottom: -8px;
}
</style>
<style>
.el-upload--text {
    display: inline;
}
</style>
